import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "PrimaryAdminTransfer"
});
const _hoisted_1 = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  d: "M20.3841 15.6302C19.9155 15.4845 19.4476 15.3668 18.9881 15.2727C19.9969 14.6334 20.8928 13.7835 21.4574 12.505C23.14 9.4196 21.9053 5.48424 18.879 3.78082C15.8526 2.0774 11.9266 3.24873 10.3569 6.4413C8.78728 9.63387 9.909 13.5692 13.1612 15.2727C9.00937 16.1261 4.1875 18.9973 4.1875 26.8716C4.1875 28.7498 6.28335 28.9706 13.0954 28.9965C12.7677 28.0368 12.5994 27.0292 12.5996 26.012C12.5999 21.3754 15.9834 17.5995 20.3852 16.7079V15.6487L20.3841 15.6302Z",
  fill: "#42526E"
}, null, -1);
const _hoisted_3 = /* @__PURE__ */ createElementVNode("path", {
  d: "M22.5279 26.8547C22.4161 26.7461 22.3633 26.5932 22.3853 26.4414L22.3765 22.9623C18.9553 22.9623 15.8596 25.8748 15.2454 29C14.8192 28.0579 14.5993 27.0405 14.5996 26.012C14.5996 21.867 18.0856 18.5081 22.3853 18.5081V15.5607C22.3634 15.4091 22.4158 15.2562 22.527 15.1474C22.7334 14.9509 23.0644 14.9509 23.2707 15.1474L28.4498 20.6203C28.5538 20.7207 28.6081 20.8596 28.5985 21.0015C28.6079 21.1433 28.5537 21.2822 28.4498 21.3826L23.2996 26.8251C23.2042 26.936 23.066 27.0122 22.9041 27.0122C22.7637 27.0119 22.6294 26.9563 22.5323 26.8581L22.5279 26.8547Z",
  fill: "#42526E"
}, null, -1);
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_4);
}
var primary_admin_transfer = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { primary_admin_transfer as default };
